import { match } from 'ts-pattern'

import type {
  ServiceGetByIdResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { RecapClassPoktanQueryResult } from './dto'
import type { RecapClassPoktan, RecapClassPoktanMeta } from './types'

import { toRecords } from './dto'

const RECAP_CLASS_POKTAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['recap_class_poktan', key] as const

interface GetRecapParams {
  region: 'national' | 'province' | 'city' | 'district'
  province_code?: string
  city_code?: string
  district_code?: string
}

type RecapClassPoktanApiResponse = ServiceGetByIdResponse<RecapClassPoktan> & {
  meta?: RecapClassPoktanMeta
}

const getRecap = (
  params: GetRecapParams
): ServiceQueryOptionType<RecapClassPoktanQueryResult> => ({
  queryKey: RECAP_CLASS_POKTAN_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const path = match(params.region)
        .with('province', () => `/province/${params.province_code}`)
        .with(
          'city',
          () => `/province/${params.province_code}/city/${params.city_code}`
        )
        .with(
          'district',
          () =>
            `/province/${params.province_code}/city/${params.city_code}/district/${params.district_code}`
        )
        .otherwise(() => '')

      const res = await api.get<RecapClassPoktanApiResponse>(
        `/report/extension-personnel-main/recap-poktan-class${path}`
      )

      return toRecords(res.data)
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const recapClassPoktan = {
  queryKey: RECAP_CLASS_POKTAN_QUERY_KEY,
  getRecap
}
